import {AES, enc} from 'crypto-js';
import {AUTH_TOKEN, SECRET} from '@jobseeker/common-core/constants';
import {
  storeObsId,
  getObsId,
  clearAuth,
  checkLoginCookieExist,
  getMachineId,
} from '@jobseeker/common-core/utils/authHelperCore';

// AES-based helpers live here (they pull in crypto-js). The crypto-free helpers
// are defined in authHelperCore.ts and re-exported below so the public API of
// this module is unchanged. Consumers that only need the crypto-free helpers
// should import them from authHelperCore directly to avoid loading crypto-js.

const storeAuth = (token: string, expires?: number): void => {
  const authMeta = {
    token: AES.encrypt(token, SECRET).toString(),
    expires,
  };

  localStorage.setItem(AUTH_TOKEN, JSON.stringify(authMeta));
};

const getAuth = () => {
  const authMeta = localStorage.getItem(AUTH_TOKEN);

  if (authMeta) {
    const parsedAuthMeta: {token: string; expires: number} =
      JSON.parse(authMeta);

    return {
      token: AES.decrypt(parsedAuthMeta['token'], SECRET).toString(enc.Utf8),
      expires: parsedAuthMeta['expires'],
    };
  }
  return {};
};

const isAuthValid = () => {
  const cookie = checkLoginCookieExist();

  if (cookie) {
    return true;
  }
  // For localhost only
  if (process.env.NEXT_PUBLIC_TRAIL === 'true') {
    const {token} = getAuth() || {};
    if (token && typeof token === 'string') {
      return true;
    }
    return false;
  }

  return false;
};

export {
  storeAuth,
  getAuth,
  clearAuth,
  checkLoginCookieExist,
  isAuthValid,
  getObsId,
  storeObsId,
  getMachineId,
};
